export default {
    methods: {
        preloadImages(urls) {
            try {
                urls.forEach(url => {
                    const image = new Image();
                    image.src = url;
                })
            } catch (e) {
                console.error('Error preloading images', e);
            }
        }
    }
}